import { render, staticRenderFns } from "./GovernateDelete.vue?vue&type=template&id=29a813a8&scoped=true&"
import script from "./GovernateDelete.vue?vue&type=script&lang=js&"
export * from "./GovernateDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a813a8",
  null
  
)

export default component.exports